import { useSyncExternalStore } from "use-sync-external-store/shim";
import { applicationCapabilitiesStore } from "../ApplicationCapabilitiesStore";
function getApplicationCapabilityReadySnapshot() {
    const state = applicationCapabilitiesStore.getState();
    return (state.applicationDefinition !== null &&
        state.viewer !== null &&
        state.featureFlags !== null &&
        state.platform !== null);
}
export function useApplicationCapabilityReady() {
    return useSyncExternalStore(applicationCapabilitiesStore.subscribe, getApplicationCapabilityReadySnapshot, () => false);
}
